import React from "react";
import ShortcutMenuWrapper from "../ShortcutMenuWrapper";
import CardColorMenuIcon from "assets/menus/master-maintenance/is-card-colors.png";
import CardGameMenuIcon from "assets/menus/master-maintenance/is-card-game.png";
import CardTypeMenuIcon from "assets/menus/master-maintenance/is-card-types.png";
import SealColorMenuIcon from "assets/menus/master-maintenance/is-seal-colors.png";
import CarrierTypeMenuIcon from "assets/menus/master-maintenance/is-carrier-types.png";
import ItemTypeMenuIcon from "assets/menus/master-maintenance/is-item-types.png";
import ItemSettingsMenuIcon from "assets/menus/master-maintenance/item-settings.svg";
import { useSelector } from "react-redux";
import { RootState } from "@app/store/store";
import { canAccess } from "@app/utils/permissionUtils";

export const ItemSettingsMenu: React.FC = () => {
    const state = useSelector((state: RootState) => state); // Get the entire state

    return (
        <ShortcutMenuWrapper
            title="shortcutMenus.itemSettings.title"
            icon={ItemSettingsMenuIcon}
            menus={[

                {
                    title: 'shortcutMenus.itemSettings.sealTypes',
                    icon: SealColorMenuIcon,
                    url: '/sealTypes/list',
                    categoryIcon: ItemSettingsMenuIcon,
                    show: canAccess(state, 'sealTypes.management')
                },
                {
                    title: 'shortcutMenus.itemSettings.sealGroups',
                    icon: SealColorMenuIcon,
                    url: '/sealGroups/list',
                    categoryIcon: ItemSettingsMenuIcon,
                    show: canAccess(state, 'sealGroups.management')
                },
                {
                    title: 'shortcutMenus.itemSettings.luggageBuckleTypes',
                    icon: CarrierTypeMenuIcon,
                    url: '/luggageBuckleTypes/list',
                    categoryIcon: ItemSettingsMenuIcon,
                    show: canAccess(state, 'luggageBuckleTypes.management')
                },

            ]}
        />
    );
}